import React from "react";
import gamesIcon from "../assets/res/game.svg";
import searchIcon from "../assets/res/search.svg";
import appsIcon from "../assets/res/apps.svg";

const NAV_TABS = [
  { id: "Games", label: "Games", icon: gamesIcon },
  { id: "Apps",  label: "Apps",  icon: appsIcon  },
  { id: "Search",label: "Search",icon: searchIcon },
];

const BottomNav = ({ page, setPage }) => {
  return (
    <div className="fixed bottom-5 left-1/2 -translate-x-1/2 z-50 w-auto">
      <div
        className="flex items-center gap-1 px-2 py-2 rounded-full shadow-2xl"
        style={{
          background: "rgba(1, 18, 38, 0.88)",
          backdropFilter: "blur(20px)",
          WebkitBackdropFilter: "blur(20px)",
          border: "1px solid rgba(255,255,255,0.10)",
          boxShadow: "0 8px 32px rgba(0,0,0,0.5), 0 0 0 0.5px rgba(255,255,255,0.05)",
        }}
      >
        {NAV_TABS.map(({ id, label, icon }) => {
          const isActive = page === id;
          return (
            <button
              key={id}
              onClick={() => setPage(id)}
              className="flex flex-col items-center justify-center rounded-full transition-all duration-200 focus:outline-none"
              style={{
                padding: isActive ? "8px 20px" : "8px 16px",
                background: isActive
                  ? "linear-gradient(135deg, #468faf44, #01497c88)"
                  : "transparent",
                boxShadow: isActive
                  ? "0 0 16px rgba(70,143,175,0.35), inset 0 0 8px rgba(70,143,175,0.1)"
                  : "none",
                border: isActive
                  ? "1px solid rgba(70,143,175,0.4)"
                  : "1px solid transparent",
              }}
            >
              <img
                src={icon}
                width={isActive ? 20 : 18}
                height={isActive ? 20 : 18}
                alt={label}
                style={{
                  opacity: isActive ? 1 : 0.45,
                  filter: isActive
                    ? "brightness(1.4) drop-shadow(0 0 4px rgba(70,143,175,0.8))"
                    : "none",
                  transition: "all 0.2s ease",
                }}
              />
              <span
                className="medium mt-0.5 leading-none"
                style={{
                  fontSize: "10px",
                  color: isActive ? "#89d4f5" : "rgba(255,255,255,0.38)",
                  transition: "color 0.2s ease",
                }}
              >
                {label}
              </span>
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default BottomNav;
